import { Box, Typography, Link as MUILink, Stack } from "@mui/material";
import DatalignChip from "datalign-module-template/components/datalign-chip";
import { useEasierTheme } from "datalign-themes";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import TagsField from "../tags-field/TagsField";

const DatatypeField = ({ datatype }: { datatype: string }) => {
  const theme = useEasierTheme();

  return (
    <Stack display="flex" sx={{ p: 1, width: "50%" }}>
      <Box>
        <Typography variant="subtitle2" textAlign="left" fontWeight="bold">
          Datatype:
        </Typography>
      </Box>
      <TagsField tags={[datatype]} tagType="Datatypes" />
    </Stack>
  );
};

export default DatatypeField;
